import { TileProps } from '../Components/Tiles/tiles';

export type TimeRemaining = {
    hours: number;
    minutes: number;
    seconds: number;
}

export const GAMES_RELATED = 'Spil, der minder om';
export const GAME_UNAVAILABLE = 'Spillet er midlertidigt ikke tilgængeligt';
export const GAME_TITLE_MISSING = 'Spil titel mangler';
export const SUPERFAVORITE_TILE_BUTTON_TEXT = 'Vælg';
export const SUPERFAVORITE_TILE_BUTTON_NEWTEXT = 'Vælg ny';
export const CATEGORY_TILE_TAGLINE = 'Kategori';

export const POT_OF_GOLD_OPENING_HOUR = 22;
export const WINNERS_LIST_PAGING_SIZE = 9;

export const getLoadingTiles = (amount: number = 6): TileProps[] => new Array(amount).fill({ isLoading: true });
export const formatNumber = (number: number | undefined, includeDecimals?: boolean): string => (number
  ? number.toLocaleString('da-DK', includeDecimals
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2, trailingZeroDisplay: 'stripIfInteger' }
    : { minimumFractionDigits: 0, maximumFractionDigits: 0 })
  : '0');
export const formatNumberToUnit = (number: number, twoDigitDecimals: boolean = false, unit: string = ' kr.') => (number ? `${formatNumber(number, twoDigitDecimals)}${unit}` : `0${unit}`);
export const getDateDiff = (startDate: string) => Math.floor((new Date().valueOf() - new Date(startDate).valueOf()) / 1000 / 60);
export const getCasinoPathname = () => window.location.pathname.split('/').at(1);

const addLeadingZero = (input: number) => input.toString().padStart(2, '0');
export const formatCountDown = (timeRemaining: TimeRemaining) => `${timeRemaining?.hours > 0 ? addLeadingZero(timeRemaining?.hours) : '00'}:${timeRemaining?.minutes ? addLeadingZero(timeRemaining?.minutes) : '00'}:${timeRemaining?.seconds ? addLeadingZero(timeRemaining?.seconds) : '00'}s`;

export const updateRemainingTime = (openingTime: string): TimeRemaining | 'closed' | null => {
  const now = new Date();
  const openingDate = new Date(openingTime);

  if (isNaN(openingDate.getTime())) {
    return null;
  }

  const diff = openingDate?.getTime() - now.getTime();

  if (diff <= 0) {
    return null;
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  if (diff > 24 * 60 * 60 * 1000) {
    return 'closed';
  } else {
    return { hours, minutes, seconds };
  }
};

// Todo: Change key to sizes instead of px!
export const fontSizes = {
  10: 'text-10',
  12: 'text-12',
  14: 'text-14',
  16: 'text-16',
  20: 'text-20',
  28: 'text-28'
} as const;

export const fontWeights = {
  medium: 'font-medium',
  bold: 'font-bold',
  extrabold: 'font-extrabold'
} as const;
